exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".manageCartPage__table___3P9fP {\n  padding-top: 39px; }\n\n.manageCartPage__user-id___zr8Ur {\n  font-size: 10px; }\n\n.manageCartPage__profile-link___X6BXt {\n  color: #3c00f9 !important; }\n\n.manageCartPage__tableWrapper___BqxNf {\n  position: relative; }\n  .manageCartPage__tableWrapper___BqxNf .manageCartPage__priceSum____96Ib {\n    position: absolute;\n    margin: 0;\n    top: 8px; }\n    .manageCartPage__tableWrapper___BqxNf .manageCartPage__priceSum____96Ib span {\n      font-weight: bold; }\n", ""]);

// exports
exports.locals = {
	"table": "manageCartPage__table___3P9fP",
	"user-id": "manageCartPage__user-id___zr8Ur",
	"profile-link": "manageCartPage__profile-link___X6BXt",
	"tableWrapper": "manageCartPage__tableWrapper___BqxNf",
	"priceSum": "manageCartPage__priceSum____96Ib"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/routes/Admin/ManageCartPage/manageCartPage.scss
// module id = 4058
// module chunks = 6